module.exports = __webpack_public_path__ + "img/cpgeo.7ed962fc.png";